<template>
  <LocalFileUploaderModal
    :modalTitle="$i18nPresenter.t('Import slides')"
    isModalVisible
    :staticState="isNotImporting"
    :uploadingState="isUploading"
    :convertingState="isConverting"
    :uploadError="docToSlideResponseError"
    :featureName="UploadFeatureName.AI_IMPORT_PPT_PDF"
    :needGenerateQuiz="needGenerateQuiz"
    :instructionText="instructionText"
    @hide="clickOnCloseDocToSlideImportModal()"
  >
    <template #footerSection>
      <div class="tab-tooltip">
        <p>{{ $i18nPresenter.t("Quiz generation is powered by AI") }}</p>
        <AIDocToQuizSecurityTooltip isDocToSlideImportModal />
      </div>
    </template>
  </LocalFileUploaderModal>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import importStatusConstant from '@/constant/importStatus'
import EventBus from '@/eventBus'
import UploadFeatureName from '@/constant/uploadFeatureName'

// components
import LocalFileUploaderModal from '@/components-v2/modals/LocalFileUploaderModal.vue'
import AIDocToQuizSecurityTooltip from '@/components-v2/openAI/AIDocToQuizSecurityTooltip.vue'

export default {
  components: {
    LocalFileUploaderModal,
    AIDocToQuizSecurityTooltip,
  },
  props: {
    docToSlideResponseError: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      file: null,
      modalTitle: this.$i18nPresenter.t('Import slides'),
      importStatusConstant,
      needGenerateQuiz: true,
      UploadFeatureName,
    }
  },
  computed: {
    ...mapGetters('docToSlideGenerator', ['docToSlideImportStage', 'docToSlideUniqueRequestId']),
    ...mapState({
      presentation: (state) => state.presentation,
    }),
    isNotImporting() {
      return this.docToSlideImportStage === this.importStatusConstant.NO_IMPORT
    },
    isUploading() {
      return this.docToSlideImportStage === this.importStatusConstant.UPLOADING
    },
    isConverting() {
      return this.docToSlideImportStage === this.importStatusConstant.CONVERTING
    },
    instructionText() {
      return this.$i18nPresenter.t('Upload a PDF, PPT or PPTX file. Up to 50MB and 100 slides.')
    },
  },
  mounted() {
    EventBus.$on('doc-to-quiz: import_convert_error', (socketData) => {
      if (socketData.requestId !== this.docToSlideUniqueRequestId) return
      this.setDocToSlideResponseErrorAction('Import failed.')
    })
  },
  destroyed() {
    EventBus.$off('doc-to-quiz: import_convert_error')
  },
  methods: {
    ...mapActions('docToSlideGenerator', [
      'setDocToSlideResponseErrorAction',
    ]),

    clickOnCloseDocToSlideImportModal() {
      this.$emit('clickOnCloseDocToSlideImportModal')
    },
  },
}
</script>

<style lang="scss" scoped>
.tab-tooltip {
  @apply pt-4;
  display: flex;
  &::v-deep {
    .doc-to-quiz__security-tooltip {
      @apply mb-0 pt-0;
    }
    .generate-from-doc__tooltip.aha-custom-tooltip.top {
      top: 8.25rem;
      left: 2.5rem;
      &::after {
        left: 44%;
      }
    }
  }
}
</style>
